export enum PolicyAdjustmentResultPath {
  RESULT = 'result',
}
